// extracted by mini-css-extract-plugin
export default {"column-title":"style_column-title__Ph7sY"};